import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_orders } from "../../store/reducers/orderReducer";
import { LanguageContext } from "../../context/LanguageContext";

const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { myOrders, order } = useSelector((state) => state.order);
  const [state, setState] = useState("all");

  useEffect(() => {
    dispatch(get_orders({ status: state, customerId: userInfo.id }));
  }, [state, dispatch, userInfo.id]);
  const { t } = useContext(LanguageContext);

  const handleRedirect = (ord) => {
    const items = (ord.products || []).reduce(
      (sum, p) => sum + (p.quantity || 0),
      0,
    );
    navigate("/payment", {
      state: {
        price: ord.price,
        items,
        orderId: ord._id,
      },
    });
  };

  const paymentLabel = (status) => {
    if (!status) return "";
    const key = status?.toString().toLowerCase();
    const map = {
      paid: t("paymentPaid"),
      unpaid: t("paymentUnpaid"),
      pending: t("paymentPending"),
      failed: t("paymentFailedLabel"),
    };
    return map[key] || status;
  };

  const deliveryLabel = (status) => {
    if (!status) return "";
    const key = status?.toString().toLowerCase();
    const map = {
      placed: t("statusPlaced"),
      pending: t("statusPending"),
      cancelled: t("statusCancelled"),
      warehouse: t("statusWarehouse"),
      delivered: t("delivered") || "Delivered",
    };
    return map[key] || status;
  };

  return (
    <div className="bg-white p-4 rounded-md">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-slate-600">
          {t("myOrders")}
        </h2>
        <select
          className="outline-none px-3 py-1 border rounded-md text-slate-600"
          value={state}
          onChange={(e) => setState(e.target.value)}
        >
          <option value="all">{t("orderStatusPlaceholder")}</option>
          <option value="placed">{t("statusPlaced")}</option>
          <option value="pending">{t("statusPending")}</option>
          <option value="cancelled">{t("statusCancelled")}</option>
          <option value="warehouse">{t("statusWarehouse")}</option>
        </select>
      </div>
      <div className="pt-4">
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3">
                  {t("orderId")}
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("price")}
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("paymentStatus")}
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("orderStatus")}
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("action")}
                </th>
              </tr>
            </thead>
            <tbody>
              {myOrders.map((o) => (
                <tr key={o._id} className="bg-white border-b">
                  <td
                    scope="row"
                    className="px-6 py-4 font-medium whitespace-nowrap"
                  >
                    {o._id}
                  </td>
                  <td
                    scope="row"
                    className="px-6 py-4 font-medium whitespace-nowrap"
                  >
                    {o.price} {t("currency")}
                  </td>
                  <td
                    scope="row"
                    className="px-6 py-4 font-medium whitespace-nowrap"
                  >
                    {paymentLabel(o.payment_status)}
                  </td>
                  <td
                    scope="row"
                    className="px-6 py-4 font-medium whitespace-nowrap"
                  >
                    {deliveryLabel(o.delivery_status)}
                  </td>
                  <td scope="row" className="px-6 py-4">
                    <Link to={`/dashboard/order/details/${o._id}`}>
                      <span className="bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded">
                        {t("view")}
                      </span>
                    </Link>
                    {o.payment_status !== "paid" && (
                      <span
                        onClick={() => handleRedirect(o)}
                        className="bg-green-100 text-green-800 text-sm font-normal mr-2 px-2.5 py-[1px] rounded cursor-pointer"
                      >
                        {t("payNow")}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Orders;
